// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BerthDateSlotModal {
  position: absolute;
  top: 53%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
  background-color: white;
  border: 2px solid #ccc;
  border-radius: 5px;
  box-shadow: 24;
  padding: 10px !important;
}

.searchBoxContainer {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 5px !important;
}

.datePickerContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}
`, "",{"version":3,"sources":["webpack://./src/components/berthDateSlotModal/BerthDateSlotModal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B","sourcesContent":[".BerthDateSlotModal {\n  position: absolute;\n  top: 53%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 50%;\n  background-color: white;\n  border: 2px solid #ccc;\n  border-radius: 5px;\n  box-shadow: 24;\n  padding: 10px !important;\n}\n\n.searchBoxContainer {\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 5px !important;\n}\n\n.datePickerContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
